import withCheckoutContext from '@/withCheckoutContext';
import PitDetailsFromRetailSession, {
  usePitDetailsFromRetailSessionProvider,
} from '@/clientState/providers/checkout/PitDetailsFromRetailSession';

export { usePitDetailsFromRetailSessionProvider };
export default withCheckoutContext(PitDetailsFromRetailSession);
